export enum FcmTokenTypes {
  web = 1,
  ios,
}
